import { motion } from "framer-motion";
import { observer } from "mobx-react-lite";

import { useEdge } from "../../ContextMenu/edge-conditions-context";

import { getStatusColor, springTransition } from "./utils";
import JusticeScaleIcon from "./JusticeScaleIcon";

import { EdgeStatusType } from "@/components/Workflows/types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const EdgeContent = ({ conditions }: { conditions: any[] }) => {
  const edge = useEdge();
  const status = edge?.status as EdgeStatusType;

  return (
    <>
      <JusticeScaleIcon
        stroke={getStatusColor(status)}
        strokeWidth={2}
        scale={0.65}
        x={-14}
        y={-12}
        pathLength
        className="pointer-events-none"
        // @ts-expect-error - TODO: fix this
        transition={{
          pathLength: {
            type: "spring",
            duration: 1,
            bounce: 0.3,
          },
          opacity: { duration: 0.2 },
          scale: {
            type: "spring",
            duration: 0.8,
            bounce: 0.4,
          },
        }}
      />
      <motion.text
        textAnchor="middle"
        dy=".3em"
        dx={conditions.length > 9 ? "18" : "12"}
        fill={getStatusColor(status)}
        fontSize="14"
        fontWeight="600"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0, opacity: 0 }}
        transition={{
          delay: 0.1,
          ...springTransition,
        }}
        className="pointer-events-none select-none"
      >
        {conditions.length}
      </motion.text>
    </>
  );
};

export default observer(EdgeContent);
